import { useState, Suspense, useCallback, useRef, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AgGridColumn, AgGridReact } from "ag-grid-react";

// import { Pagination } from "@material-ui/lab";
import { CustomPagination } from "../../../shared";
import { Button } from "@material-ui/core";
import { CellValueChangedEvent, ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";

import { UIContext } from "../../../../contexts";
import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import { api } from "../../../../utils/api";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import getAgGridHeight from "../../../../utils/commonFunctions/getAgGridHeight";
import { ReportType } from "../../../../@types/reportType.types";
import { useEmployerRoute } from "../../../../hooks";
import useRouteParam from "../../../../hooks/useRouteParam";
import ExtractRouteParams from "../../../../utils/commonFunctions/extractRouteParams";
import { LINK } from "../../../../config/config";
import { dateTimeZoneConverter } from "../../../../utils/commonFunctions/date";

interface YearlyOpenEnrollmentReportProps {
	dataReports: any[];
}

const YearlyOpenEnrollmentReport = ({ dataReports }: YearlyOpenEnrollmentReportProps): JSX.Element => {
	// console.log("YearlyOpenEnrollmentReport data: ", dataReports);
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const agGridRef = useRef<any>(null);
	const [isRowSelected, setIsRowSelected] = useState(false);
	const navigate = useNavigate();
	const isEmployerRoute = useEmployerRoute();
	const queryGroupNumber = useRouteParam("gn");
	const routeParam = ExtractRouteParams(); // This is to extract the route after ?(Question Mark)
	const { setDashboardHeader } = useContext(UIContext);
	const [gridHeight, setGridHeight] = useState("300px");
	// const [reportData, setReportData] = useState<ReportType[]>([
	// 	{
	// 		report_type: "Active Core Enrollment(s) for YOE Report",
	// 		description: "This report will pull the active Core Enrollments Details for YOE - 2025.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Active VEB Enrollment(s) for YOE Report",
	// 		description: "This report will pull the active Core Enrollments Details for YOE - 2025.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Core Previously Active Currently Waived for YOE Report",
	// 		description:
	// 			"This report will pull the Core Enrollments of Previously Active Currently Waived for YOE -2025.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "VEB Previously Active Currently Waived for YOE Report",
	// 		description:
	// 			"This report will pull the VEB Enrollments of Previously Active Currently Waived for YOE -2025.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Core Action Taken or Not Taken for YOE Report",
	// 		description:
	// 			"This report will pull the VEB Enrollments of Previously Active Currently Waived for YOE -2025.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "VEB Action Taken or Not Taken for YOE Report",
	// 		description:
	// 			"This report will pull the VEB Enrollments of Previously Active Currently Waived for YOE -2025.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	}
	// ]);

	// const getReports = useCallback(async () => {
	// 	const groupNumberQuery = {
	// 		group_number: 220
	// 	};

	// 	const response = await api.reports.getReportLogs(groupNumberQuery);
	// 	// console.log("Report Logs", response);

	// 	// if (response) {
	// 	// 	for (let i = 0; i < reportData.length; i++) {
	// 	// 		for (let j = 0; j < response.length; j++) {
	// 	// 			if (reportData[i].report_type === response[j].name) {
	// 	// 				reportData[i].last_generated_by =
	// 	// 					response[j].last_generated_first_name + " " + response[j].last_generated_last_name;
	// 	// 				reportData[i].last_generated_on = response[j].last_date;
	// 	// 			}
	// 	// 		}
	// 	// 	}
	// 	// 	setReportData(Object.assign([], { ...reportData }));
	// 	// }

	// 	reportData.forEach((data: any) => {
	// 		response.forEach((res_data: any) => {
	// 			// data which are present in both the response and constants
	// 			if (data.report_type === res_data.name) {
	// 				data.last_generated_by =
	// 					res_data.last_generated_first_name + " " + res_data.last_generated_last_name;
	// 				data.last_generated_on = res_data.last_date;
	// 				setReportData(Object.assign([], reportData, { ...data }));
	// 			}
	// 		});
	// 	});
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, []);

	const handleAgGridReady = (params: GridReadyEvent) => {
		// eslint-disable-next-line no-unused-vars
		const { api, columnApi } = params;
		setAgGridAPI(api);
		setAgGridColumnAPI(columnApi);
		const columnIds: any[] = [];
		columnApi?.getAllColumns()?.forEach((column: any) => {
			columnIds.push(column.colId);
		});
		columnApi.autoSizeColumns(columnIds);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
	};

	const handleDateCellRenderer = ({ value }: { value: any }) => {
		const date = dateTimeZoneConverter(value as string) as string;
		return <div>{value ? date : "N/A"}</div>;
	};

	const handleGenerateReportClick = useCallback(
		({
			_isEmployerRoute,
			_queryGroupNumber
		}: {
			_isEmployerRoute: boolean | null;
			_queryGroupNumber: number | null;
		}) => {
			if (agGridRef?.current) {
				const focusedCell = agGridRef.current.api.getFocusedCell();
				const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
				const {
					data: {
						report_route,
						report_name,
						report_type,
						report_description,
						report_form_structure,
						api_route
					}
				} = row;

				let pathname;

				// if (report_type === "Active Core Enrollment(s) for YOE Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/active-core-enrollment-for-yoe?${routeParam}`)
				// 		: (pathname = "/report/active-core-enrollment-for-yoe");
				// } else if (report_type === "Active VEB Enrollment(s) for YOE Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/active-veb-enrollment-for-yoe?${routeParam}`)
				// 		: (pathname = "/report/active-veb-enrollment-for-yoe");
				// } else if (report_type === "Core Previously Active Currently Waived for YOE Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/core-previously-active-currently-waived?${routeParam}`)
				// 		: (pathname = "/report/core-previously-active-currently-waived");
				// } else if (report_type === "VEB Previously Active Currently Waived for YOE Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/veb-previously-active-currently-waived?${routeParam}`)
				// 		: (pathname = "/report/veb-previously-active-currently-waived");
				// } else if (report_type === "Core Action Taken or Not Taken for YOE Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/core-action-taken-or-not-taken?${routeParam}`)
				// 		: (pathname = "/report/core-action-taken-or-not-taken");
				// } else if (report_type === "VEB Action Taken or Not Taken for YOE Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/veb-action-taken-or-not-taken?${routeParam}`)
				// 		: (pathname = "/report/veb-action-taken-or-not-taken");
				// }

				if (_isEmployerRoute === true && _queryGroupNumber !== null) {
					pathname = `/employer${report_route}?${routeParam}`;
				} else {
					pathname = `${report_route}`;
				}

				// navigate(pathname as string);
				navigate(pathname, {
					state: {
						report_name,
						report_type,
						report_description,
						report_form_structure,
						api_route
					}
				});
			}
		},
		[navigate, routeParam]
	);

	const handleActionButtonRender = ({
		_isEmployerRoute,
		_queryGroupNumber
	}: {
		_isEmployerRoute: boolean | null;
		_queryGroupNumber: number | null;
	}) => {
		return (
			<Button
				className="ag-grid-cell-button"
				variant="outlined"
				onClick={() =>
					handleGenerateReportClick({
						_isEmployerRoute,
						_queryGroupNumber
					})
				}
			>
				Generate Report
			</Button>
		);
	};

	const handleSelectionChanged = useCallback(() => {
		const selectedRow = agGridAPI?.getSelectedRows()[0];
		if (selectedRow) {
			setIsRowSelected(true);
		} else {
			setIsRowSelected(false);
		}
	}, [agGridAPI]);

	const handleCellValueRender = ({ value }: { value: string }) => {
		return <div>{value ? <div>{value}</div> : <div style={{ marginLeft: 15 }}>N/A</div>}</div>;
	};

	// useEffect(() => {
	// 	getReports();
	// }, [getReports]);

	useEffect(() => {
		const _gridHeight = getAgGridHeight(dataReports.length);
		setGridHeight(_gridHeight);
	}, [dataReports.length]);

	// console.log("Report Data -> ", reportData);

	return (
		<div className="group-home-page">
			<div className="group-home-pg-grid-container">
				<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
					<AgGridReact
						ref={agGridRef}
						rowData={dataReports}
						onGridReady={handleAgGridReady}
						onFirstDataRendered={handleFirstDataRendered}
						rowSelection={"Single"}
						animateRows
						defaultColDef={{
							filter: "agTextColumnFilter",
							floatingFilter: true,
							resizable: true
						}}
						onSelectionChanged={handleSelectionChanged}
						frameworkComponents={{
							handleActionButtonRender: handleActionButtonRender,
							handleCellValueRender: handleCellValueRender,
							handleDateCellRenderer: handleDateCellRenderer
							// customFloatingFilter: CustomFloatingFilter,
							// customFilter: CustomFilter,
							// schema: groupsFilterSchema,
							// functionToBePassed: functionToBePassed,
							// setPayloadSchema: setGroupsFilterSchema,
							// setParentSchema: setGroups
						}}
						onCellValueChanged={(params: CellValueChangedEvent) => {
							params.api.refreshCells({
								force: true,
								columns: ["branding"]
							});
						}}
						enableCellChangeFlash={true}
					>
						<AgGridColumn
							field="report_name"
							headerName="Report Name"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							// cellRenderer="handleCellValueRender"
						></AgGridColumn>
						<AgGridColumn
							field="report_description"
							headerName="Description"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							// cellRenderer="handleCellValueRender"
						></AgGridColumn>
						<AgGridColumn
							// field="last_generated_by"
							field="report_logs.last_generated_by"
							headerName="Last Generated by"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleCellValueRender"
						></AgGridColumn>
						<AgGridColumn
							// field="last_generated_on"
							field="report_logs.last_generated_on"
							headerName="Last Generated On"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleDateCellRenderer"
						></AgGridColumn>
						<AgGridColumn
							field="action"
							headerName="Action"
							cellRenderer="handleActionButtonRender"
							cellRendererParams={{
								_isEmployerRoute: isEmployerRoute,
								_queryGroupNumber: queryGroupNumber
							}}
							filter={false}
						></AgGridColumn>
					</AgGridReact>
				</div>
			</div>
		</div>
	);
};

export default YearlyOpenEnrollmentReport;
